import styled, { css } from "styled-components";
import theme from "../../../../styles/themes/main-theme";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const RateComponent = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;
`;

const PALLET_COLORS = [
  theme.colors.npsRateColor1,
  theme.colors.npsRateColor2,
  theme.colors.npsRateColor3,
  theme.colors.npsRateColor4,
  theme.colors.npsRateColor5,
];
export const RateButton = styled.button<{ selected: boolean }>`
  width: 10%;
  padding: 0.5rem 0;
  border: none;
  color: ${({ theme }) => theme.colors.white.main};
  font-size: 1rem;
  font-weight: 600;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-radius: 0 8px 8px 0;
  }
  
  ${PALLET_COLORS.map((color, index) => css`
    &.btn-${index*2 + 1}, &.btn-${index*2 + 2} {
      background-color: ${color.hover};
    }
  `)}

  ${({ selected }) => selected && css`
    ${PALLET_COLORS.map((color, index) => css`
      &.btn-${index*2 + 1}, &.btn-${index*2 + 2} {
        background-color: ${color.main};
      }
    `)}
  `}
`;
